import { getResponsiveStyles } from '../../../component-themes';
export const highlightWrapperBase = (tokens) => ({ size }) => {
    return {
        background: tokens.styles[`highlightWrapper-${size}-background`],
        paddingBlockStart: tokens.styles[`highlightWrapper-${size}-paddingTop`],
        paddingBlockEnd: tokens.styles[`highlightWrapper-${size}-paddingBottom`],
    };
};
export const highlightWrapper = (tokens) => ({ size }) => getResponsiveStyles(size, (size) => highlightWrapperBase(tokens)({ size }));
